export const AUDIT_ACTION_LABELS: Record<string, string> = {
  "auth.login": "تسجيل دخول",
  "auth.logout": "تسجيل خروج",
  "auth.change-password": "تغيير كلمة المرور",
  "content.create": "إنشاء محتوى",
  "content.delete": "حذف محتوى",
  "content.submit": "إرسال للمراجعة",
  "content.approve": "موافقة",
  "content.reject": "رفض",
  "content.publish": "نشر",
  "content.rollback": "استعادة نسخة",
  "content.assign-department": "تعيين دائرة",
  "users.create": "إنشاء مستخدم",
  "users.invite": "دعوة مستخدم",
  "users.update": "تحديث مستخدم",
  "users.deactivate": "تعطيل مستخدم",
  "users.assign-role": "تعيين دور",
  "roles.create": "إنشاء دور",
  "roles.update": "تحديث دور",
  "roles.delete": "حذف دور",
  "permissions.update-role-templates": "تحديث صلاحيات الدور",
  "permissions.update-user-overrides": "تحديث صلاحيات المستخدم",
};

export const AUDIT_ACTION_OPTIONS = Object.entries(AUDIT_ACTION_LABELS).map(
  ([value, label]) => ({ value, label }),
);

export function getAuditActionLabel(action: string): string {
  return AUDIT_ACTION_LABELS[action] ?? action;
}
